<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M17.25,24c-0.414,0-0.75-0.336-0.75-0.75c0-2.068-2.019-3.75-4.5-3.75c-2.481,0-4.5,1.682-4.5,3.75
		C7.5,23.664,7.164,24,6.75,24h-4.5c-0.262,0-0.5-0.133-0.638-0.355c-0.138-0.223-0.15-0.496-0.033-0.73l0.03-0.06
		c0.017-0.034,0.036-0.065,0.057-0.095c1.397-1.986,2.669-4.089,3.788-6.259H4.5c-0.414,0-0.75-0.336-0.75-0.75S4.086,15,4.5,15h1.7
		c0.696-1.462,1.332-2.973,1.894-4.5H7.5c-0.414,0-0.75-0.336-0.75-0.75S7.086,9,7.5,9h1.119C9.048,7.719,9.428,6.427,9.75,5.155
		V3.75c0-0.96,0.615-1.808,1.5-2.121V0.75C11.25,0.336,11.586,0,12,0s0.75,0.336,0.75,0.75v0.879c0.885,0.314,1.5,1.162,1.5,2.121
		v1.405C14.572,6.426,14.952,7.719,15.381,9H16.5c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75h-0.594
		c0.562,1.527,1.198,3.038,1.894,4.5h1.7c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75h-0.954
		c1.118,2.169,2.391,4.271,3.788,6.258c0.022,0.031,0.041,0.063,0.058,0.096l0.03,0.06c0.117,0.234,0.105,0.507-0.032,0.729
		C22.252,23.864,22.008,24,21.75,24H17.25z M20.338,22.5c-1.278-1.917-2.445-3.931-3.475-6H7.136c-1.031,2.07-2.197,4.084-3.475,6
		h2.4C6.481,19.95,9.017,18,12,18c2.983,0,5.519,1.95,5.939,4.5H20.338z M16.144,15c-0.676-1.469-1.292-2.979-1.834-4.5H9.69
		c-0.542,1.52-1.157,3.03-1.834,4.5H16.144z M13.802,9c-0.322-0.993-0.617-1.999-0.881-3h-1.842c-0.263,1.001-0.558,2.007-0.88,3
		H13.802z M12.75,4.5V3.75C12.75,3.336,12.414,3,12,3s-0.75,0.336-0.75,0.75V4.5H12.75z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'landmark-eiffel-tower',
    },
    name: {
      type: String,
      required: false,
      default: 'LandmarkEiffelTower',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>